



























import Vue from "vue";
import Component from "vue-class-component";
import Page from "@/components/layout/page.vue";
import { usePermissions } from "@/store/modules/auth";

// See https://github.com/kaorun343/vue-property-decorator for all options

@Component({
    name: "okta-callback",
    components: { Page },
})
export default class OktaCallback extends Vue {
    pageVisible: boolean = false;
    user: any = null;

    async mounted() {
        try {
            const { refreshPermissions } = usePermissions();

            await this.handleCallback();
            this.user = await this.$auth.getUser();
            this.pageVisible = true;

            await refreshPermissions();
            await this.continue();
        } catch (e) {
            // No longer needed - the error is displayed on the login page
            // this.$tosti.error({ message: `Login failed: ${e.message}` });
            await this.$router.replace({ name: "login", params: { loginError: e } });
            console.warn(e);
        } finally {
        }
    }

    async handleCallback() {
        await this.$auth.handleAuthentication();

        const user = await this.$auth.getUser();
        // this.$tosti.success({ message: `Welcome to the console, ${user.name}!` });
    }

    async continue() {
        await new Promise((r) => setTimeout(r, 2000));
        this.pageVisible = false;
        await new Promise((r) => setTimeout(r, 500));
        await this.$router.replace({ name: "dashboard" });
    }
}
